import { render } from "./TopBar.vue?vue&type=template&id=1cbfbaa4&ts=true"
import script from "./TopBar.vue?vue&type=script&lang=ts"
export * from "./TopBar.vue?vue&type=script&lang=ts"

import "./TopBar.vue?vue&type=style&index=0&id=1cbfbaa4&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__